import { wrapCurrency } from '@/utils/tool';
import classNames from 'classnames';
import { ProductCardProps } from '../../types';
import { twMerge } from 'tailwind-merge';
import VolumePricing from '../../volumePricing';

const getBasePrice = (data, showBasePrice, showSpecialPrice) => {
  if (!!showBasePrice && !!data?.base_price) {
    let comparePrice = data?.price;
    //秒杀价取值调整
    if (showSpecialPrice) {
      comparePrice = data?.special_price;
    }
    if (data?.base_price > comparePrice) {
      return data?.base_price;
    }
  }
  return null;
};

const CardBodyPrice: React.FC<Partial<
  ProductCardProps & {
    showSpecialPrice?: boolean;
    volumeCls?: string;
  }
>> = props => {
  const {
    data,
    showBasePrice = true,
    showSpecialPrice,
    className,
    basePriceCls,
    priceCls,
    volumeCls,
    volumeClasses
  } = props;

  const priceId = `${data.id || data.product_id}-price`;

  const renderBasePrice = () => {
    if (!!showBasePrice && !!data?.base_price) {
      let comparePrice = data?.price;
      //秒杀价取值调整
      if (showSpecialPrice) {
        comparePrice = data?.special_price;
      }
      if (data?.base_price > comparePrice) {
        return (
          <div
            data-testid="wid-product-card-base-price"
            className={twMerge(classNames('enki-body-sm text-surface-100-fg-minor line-through'), basePriceCls)}>
            {`$${wrapCurrency(data?.base_price)}`}
          </div>
        );
      }
    }
    return null;
  };

  const renderSubscribePrice = () => {
    if (data?.subscribe_price || data?.subscribe_price_tip) {
      return (
        <div
          data-testid="wid-product-card-subscribe-price"
          className="flex items-center mt-0.5 text-shade-cool-base-7 line-clamp-1">
          {!!data?.subscribe_price && (
            <span
              data-testid="txt-product-card-subscribe-price"
              className="enki-body-2xs-medium mr-1">{`$${wrapCurrency(data?.subscribe_price)}`}</span>
          )}
          {data?.subscribe_price_tip && (
            <span
              data-testid="txt-product-card-subscribe-price-tip"
              className="enki-body-3xs mt-[1px]"
              dangerouslySetInnerHTML={{ __html: `(${data?.subscribe_price_tip})` }}></span>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div data-testid="wid-product-card-price" role="group" className={twMerge('mb-1', className)}>
      {!!data?.volume_price_support ? (
        <VolumePricing
          className={volumeCls}
          classes={volumeClasses}
          volumePrice={String(data?.volume_price)}
          price={showSpecialPrice ? data?.special_price : data?.price}
          basePrice={getBasePrice(data, showBasePrice, showSpecialPrice)}
          volumeThreshold={data?.volume_threshold}
        />
      ) : (
        <div className="flex items-baseline flex-row flex-wrap">
          <div
            className={twMerge(
              'enki-body-base-strong text-pricing-txt mr-1',
              props.cardSize === 'sm' && 'leading-5 text-[17px]',
              priceCls
            )}
            id={priceId}
            data-testid="wid-product-card-price-value"
            data-role="text">
            {`$${wrapCurrency(showSpecialPrice ? data?.special_price : data?.price)}`}
          </div>

          {renderBasePrice()}
        </div>
      )}
      {/* 订阅价格展示 */}
      {renderSubscribePrice()}
    </div>
  );
};

export default CardBodyPrice;
